import React from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { loadDistributions } from "redux/distributions/distributionsFunctions";
import { getReportDateSelector } from "redux/user/user";
import { RootState } from "redux/rootReducer";
import PieChart from "components/PieChart";

const Distributions = () => {
  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 960px)");

  const dispatch = useDispatch();

  const reportControlId = useSelector(
    (state: RootState) => state.user.reportControlId
  );
  const reportDate = useSelector(getReportDateSelector);

  const distribution1 = useSelector(
    (state: RootState) => state.distributions[1]?.all?.data ?? []
  );
  const distribution1Loading = useSelector(
    (state: RootState) => state.distributions[1]?.all?.loading
  );
  const distribution2 = useSelector(
    (state: RootState) => state.distributions[2]?.all?.data ?? []
  );
  const distribution2Loading = useSelector(
    (state: RootState) => state.distributions[2]?.all?.loading
  );
  const distribution3 = useSelector(
    (state: RootState) => state.distributions[3]?.all?.data ?? []
  );
  const distribution3Loading = useSelector(
    (state: RootState) => state.distributions[3]?.all?.loading
  );

  React.useEffect(() => {
    if (reportControlId && reportDate) {
      dispatch(loadDistributions(1, reportControlId, reportDate));
      dispatch(loadDistributions(2, reportControlId, reportDate));
      dispatch(loadDistributions(3, reportControlId, reportDate));
    }
  }, [dispatch, reportControlId, reportDate]);

  return (
    <>
      <Grid
        item
        md={4}
        sm={12}
        style={{
          borderRight: matchesMediaQuery ? "1px solid #D7D7D7" : "none",
          borderBottom: matchesMediaQuery ? "none" : "1px solid #D7D7D7",
          marginBottom: 32,
          padding: matchesMediaQuery ? "0 16px" : 0,
        }}
      >
        <PieChart
          data={distribution1.map((d) => ({
            name: d.Category,
            value: d.Value,
          }))}
          label={t("wealth_distribution")}
          loading={distribution1Loading}
        />
      </Grid>
      <Grid
        item
        md={4}
        sm={12}
        style={{
          borderRight: matchesMediaQuery ? "1px solid #D7D7D7" : "none",
          borderBottom: matchesMediaQuery ? "none" : "1px solid #D7D7D7",
          marginBottom: 32,
          padding: matchesMediaQuery ? "0 16px" : 0,
        }}
      >
        <PieChart
          data={distribution2.map((d) => ({
            name: d.Category,
            value: d.Value,
          }))}
          label={t("location")}
          loading={distribution2Loading}
        />
      </Grid>
      <Grid
        item
        md={4}
        sm={12}
        style={{ marginBottom: 32, padding: matchesMediaQuery ? "0 16px" : 0 }}
      >
        <PieChart
          data={distribution3.map((d) => ({
            name: d.Category,
            value: d.Value,
          }))}
          label={t("currency")}
          loading={distribution3Loading}
        />
      </Grid>
    </>
  );
};

export default React.memo(Distributions);
